// Auto-ported from the age-of-mcp /gallery. Low-poly parts flattened to a
// self-contained model (no shared helpers, no animations).
import * as THREE from "three";
import { defineModel } from "../../lib";

export const waterBuffalo = defineModel({
  id: "water-buffalo",
  scale: 4.27, // real-world size correction (see Model.scale)
  batchId: "future",
  name: "Water buffalo",
  tags: ["creature","water","buffalo","low-poly","age-of-mcp","future"],
  summary: "A water buffalo — heavy draught, milk and meat in warm wetlands.",
  description: "Ported from the age-of-mcp gallery (future library).",
  author: "age-of-mcp",
  footprint: 0.13,
  fits: ["draft"],
  parts: () => [
      { geometry: new THREE.CylinderGeometry(0.013, 0.011, 0.05, 5), color: "#454049", position: [0.055, 0.025, 0.04] },
      { geometry: new THREE.CylinderGeometry(0.013, 0.011, 0.05, 5), color: "#454049", position: [0.055, 0.025, -0.04] },
      { geometry: new THREE.CylinderGeometry(0.013, 0.011, 0.05, 5), color: "#454049", position: [-0.055, 0.025, 0.04] },
      { geometry: new THREE.CylinderGeometry(0.013, 0.011, 0.05, 5), color: "#454049", position: [-0.055, 0.025, -0.04] },
      { geometry: new THREE.IcosahedronGeometry(0.066, 0), color: "#5b5560", position: [0, 0.1, 0], scale: [1.7, 1, 1.15] },
      { geometry: new THREE.IcosahedronGeometry(0.04, 0), color: "#6a6470", position: [0.092, 0.105, 0], scale: [1.05, 0.95, 1.05] },
      { geometry: new THREE.BoxGeometry(0.036, 0.028, 0.036), color: "#6a6470", position: [0.108, 0.099, 0] },
      { geometry: new THREE.ConeGeometry(0.012, 0.075, 5), color: "#3a363f", position: [0.082, 0.138, 0.03], rotation: [1, 0, 1.4], scale: [1, 1, 0.5] },
      { geometry: new THREE.ConeGeometry(0.012, 0.075, 5), color: "#3a363f", position: [0.082, 0.138, -0.03], rotation: [-1, 0, 1.4], scale: [1, 1, 0.5] },
      { geometry: new THREE.IcosahedronGeometry(0.0035, 0), color: "#181410", position: [0.108, 0.112, 0.022] },
      { geometry: new THREE.IcosahedronGeometry(0.0035, 0), color: "#181410", position: [0.108, 0.112, -0.022] },
      { geometry: new THREE.CylinderGeometry(0.005, 0.004, 0.06, 4), color: "#5b5560", position: [-0.104, 0.07, 0], rotation: [0, 0, 2.5] },
      { geometry: new THREE.IcosahedronGeometry(0.012, 0), color: "#3a363f", position: [-0.121, 0.046, 0], scale: [0.8, 1.2, 0.8] },
    ],
  animations: [],
});
